import { Injectable, OnDestroy } from '@angular/core';
import { Task } from '@app/efficiency-analysis/models/heat-task';
import { EfficiencyAnalysisMeters } from '@app/shared/models/efficiency-analysis/efficiency-analysis-meters';
import { flatMapDeep } from 'lodash';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BuildingEfficiencyWizardStore } from '../building-efficiency-wizard.component.store';

@Injectable({
  providedIn: 'root',
})
export class HeatSelectionService implements OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  public efficiencyMeters: EfficiencyAnalysisMeters[] = [];
  public toggledSubject$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public toggledAction$: Observable<boolean> = this.toggledSubject$.asObservable();

  constructor(private buildingEfficiencyWizardStore: BuildingEfficiencyWizardStore) {
    this.buildingEfficiencyWizardStore.efficiencyAnalysisMeters$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((meters: EfficiencyAnalysisMeters[]) => (this.efficiencyMeters = meters));
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public mapHeatSelectionsToEfficiencyMeters(heatSelections: Task[], efficiencyAnalysisId: string): EfficiencyAnalysisMeters[] {
    return flatMapDeep(
      heatSelections
        ? heatSelections.map((heat: Task) => heat.subtasks?.map((meter: Task) => this.mapMetersToEfficiencyMeters(efficiencyAnalysisId, heat.name, meter)))
        : ([] as EfficiencyAnalysisMeters[]),
    );
  }

  private mapMetersToEfficiencyMeters(efficiencyAnalysisId: string, energyTypeName: string, meter: Task): EfficiencyAnalysisMeters {
    return {
      efficiencyAnalysisId: efficiencyAnalysisId,
      energyTypeName: energyTypeName,
      guid: meter.guid,
      isSelected: meter.completed,
      meterNumber: meter.meterNumber,
      value: this.setValue(meter),
    } as EfficiencyAnalysisMeters;
  }

  private setValue(meter: Task): number | undefined {
    if (meter.completed && meter.value) {
      if (typeof meter.value === 'number') {
        return meter.value;
      } else {
        return (meter.value as any).replace(',0', '').split(',').join('').split('.').join('');
      }
    }
    return undefined;
  }
}
